<template>
    <div class="container-fuild summary-box">
        <div class="container">
            <div class="breakupSummary">
                <div>
                    <span>{{ totalReviewCount }}</span>
                    <span>Reviews</span>
                </div>
                <div>
                    <span>{{ totalReviewCountApproved }}</span>
                    <span>Approved</span>
                </div>
                <div>
                    <span>{{ totalReviewCountPending }}</span>
                    <span>Pending</span>
                </div>
                <div>
                    <span>{{ totalReviewCountRejected }}</span>
                    <span>Rejected</span>
                </div>
                <div>
                    <span class="rating">{{ averageOverallRating.toFixed(1) }}</span>
                    <span class="maxRating">/5</span>
                    <div class="sm">Star Rating Average</div>
                </div>
            </div>
            <div id="reviews_settings_link">
                <a href="javascript:void(0)" class="btn btn-default" @click="showReviewsSettingsModal">Reviews
                    Settings</a>
            </div>
        </div>

        <modal :show="reviewsSettingsModalVisible" title="Reviews Settings" ok-text="Save" @ok="saveSettings"
               @cancel="closeReviewsSettingsModal">
            <div id="reviews_settings">
                <p>Notifications are automatically sent to the email address below when a new review is submitted.
                    Multiple email addresses can be entered, separated by commas.</p>
                <p>
                    Your review page is
                    <a :href="reviewURL" target="_blank">{{ reviewURL }}</a>
                </p>
                <p>
                    Your write a review link is
                    <a :href="`${reviewURL}#writereview`" target="_blank">{{ reviewURL }}#writereview</a>
                </p>
                <div class="form-group m-t-md">
                    <label for="reviews_contact_name">Contact Name</label>
                    <input id="reviews_contact_name" name="reviews_contact_name" class="form-control" maxlength="100"
                           v-model="reviews_contact_name">
                    <label class="error" v-show="vErrors.has('description')">{{ vErrors.first('description') }}</label>
                </div>
                <div class="form-group">
                    <label for="reviews_contact_emails">Contact Emails</label>
                    <textarea id="reviews_contact_emails" name="reviews_contact_emails" class="form-control"
                              maxlength="600"
                              v-model="reviews_contact_emails"></textarea>
                </div>
                <div class="form-group">
                    <label for="reviews_notification_level">Notification Level</label>
                    <select id="reviews_notification_level" name="reviews_notification_level" class="form-control"
                            v-model="reviews_notification_level">
                        <option v-for="notification_level in notification_levels" :value="notification_level.id">
                            {{ notification_level.label }}
                        </option>
                    </select>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import Swal from 'sweetalert2'

export default {
    name: 'reviews-summary',

    props: {
        'averageOverallRating': {
            type: Number,
            required: true
        },
        'totalReviewCount': {
            type: Number,
            required: true
        },
        'totalReviewCountApproved': {
            type: Number,
            required: true
        },
        'totalReviewCountPending': {
            type: Number,
            required: true
        },
        'totalReviewCountRejected': {
            type: Number,
            required: true
        },
        vertical: {
            type: String,
            required: true
        },
        advertiser: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            reviews_contact_name: null,
            reviews_contact_emails: null,
            reviews_notification_level: 1,
            notification_levels: [
                {id: 1, label: '1-2 star reviews'},
                {id: 2, label: '1-3 star reviews'},
                {id: 3, label: '1-4 star reviews'},
                {id: 4, label: 'All reviews'},
            ],
            reviewsSettingsModalVisible: false,
        }
    },

    computed: {
        reviewURL() {
            const vertical = this.vertical === 'mortgage' ? 'mortgages' : this.vertical

            return `https://www.bankrate.com/${vertical}/reviews/${this.advertiser.seo_name}/`
        },
    },

    methods: {
        getSettings(callback) {
            $.loading.show()

            axios.get('/api/tools/consumer-reviews-settings')
                .then(response => {
                    this.reviews_contact_name = response.data.data.reviews_contact_name
                    this.reviews_contact_emails = response.data.data.reviews_contact_emails
                    this.reviews_notification_level = response.data.data.reviews_notification_level

                    $.loading.hide()

                    if (callback) {
                        callback()
                    }
                })
                .catch(() => {
                    $.loading.hide()
                    new Swal('Whoops!', 'Something went wrong. Please contact support.', 'error')
                })
        },

        saveSettings() {
            $.loading.show()

            axios.post('/api/tools/consumer-reviews-settings', {
                reviews_contact_name: this.reviews_contact_name,
                reviews_contact_emails: this.reviews_contact_emails,
                reviews_notification_level: this.reviews_notification_level,
            })
                .then(() => {
                    $.loading.hide()
                    this.reviewsSettingsModalVisible = false
                })
                .catch(() => {
                    $.loading.hide()
                    new Swal('Whoops!', 'Something went wrong. Please contact support.', 'error')
                })
        },

        showReviewsSettingsModal() {
            this.getSettings(() => {
                this.reviewsSettingsModalVisible = true
            })
        },

        closeReviewsSettingsModal() {
            this.reviewsSettingsModalVisible = false
        },
    },
}
</script>

<style scoped>
.breakupSummary {
    width: 860px;
}

.breakupSummary div {
    margin: 13px 18px 13px 0;
}

.breakupSummary span:last-child:not(.maxRating) {
    margin-right: 18px !important;
}

.breakupSummary span.maxRating {
    margin-right: 15px !important;
}

.breakupSummary div .sm {
    margin-right: 0;
}

#reviews_settings_link {
    font-size: 17px;
    padding-top: 19px;
}

#reviews_settings_link .btn {
    padding: 10px 12px;
}

#reviews_settings {
    padding: 4px 25px 4px 25px;
}

#reviews_settings p {
    font-size: 13px !important;
}
</style>
